/**
 * Single funnel for unexpected errors.
 *
 * Everything that catches a crash should report it here rather than calling
 * console.error directly, so wiring up a real reporting service (Sentry,
 * Rollbar, ...) later is a one-file change.
 */
export interface ErrorContext {
  /** Where the error came from, e.g. 'route-boundary' or 'app-boundary'. */
  source?: string;
  /** React's component stack, when the caller is an error boundary. */
  componentStack?: string;
  [key: string]: unknown;
}

export const reportError = (error: unknown, context: ErrorContext = {}): void => {
  console.error('[reportError]', error, context);
};
